<template>
  <roe-chart-table-switch
    name="Lead Indicators track saving behavior - Participation Rate"
    id="lead-indicators-track"
  >
    <template #chartView>
      <div class="table-row" v-for="year in lagIndicatorYears">
        <div class="table-unit table-desc-unit">
          {{ year }}
        </div>
        <div class="table-unit" v-for="(design, index) in designs">
          <roe-pie
            :value="design.participation_rate[year]"
            :color="designColors[index]"
            :star="
              design.participation_rate[year] >
                industryBenchmark.participation_rate
            "
            :mark="industryBenchmark.participation_rate"
          ></roe-pie>
        </div>
      </div>
      <div class="table-description">
        <div class="table-description-unit">
          <span class="triangle"></span> Industry Median:
          {{ industryBenchmark.participation_rate | percentage }}
        </div>
        <div class="table-description-unit">
          <span class="star"></span> Better than Industry Median
        </div>
      </div>
    </template>

    <template #tableView>
      <div class="table-row" v-for="year in lagIndicatorYears">
        <div class="table-unit table-desc-unit">
          {{ year }}
        </div>
        <div class="table-unit" v-for="design in designs">
          <span
            class="common-label"
            :class="{
              star:
                design.participation_rate[year] >
                industryBenchmark.participation_rate
            }"
          >
            {{ design.participation_rate[year] | percentage }}</span
          >
        </div>
      </div>
      <div class="table-description">
        <div class="table-description-unit">
          <span class="triangle"></span> Industry Median:
          {{ industryBenchmark.participation_rate | percentage }}
        </div>
        <div class="table-description-unit">
          <span class="star"></span> Better than Industry Median
        </div>
      </div>
    </template>
  </roe-chart-table-switch>
</template>

<script>
import RoePie from "@/components/charts/Pie";
import RoeChartTableSwitch from "@/components/alternative-designs/_shared/ChartTableSwitch";
import { mapGetters } from "vuex";

export default {
  name: "RoeParticipationRate",
  computed: {
    ...mapGetters([
      "designs",
      "lagIndicatorYears",
      "designColors",
      "industryBenchmark"
    ])
  },
  components: {
    RoePie,
    RoeChartTableSwitch
  }
};
</script>
